import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      id: 'orders',
      title: 'Pending Orders',
      count: 23,
      description: 'Orders awaiting processing',
      icon: 'Package',
      color: 'bg-warning/10 text-warning',
      action: 'View Orders'
    },
    {
      id: 'inventory',
      title: 'Low Stock Alerts',
      count: 8,
      description: 'Products running low',
      icon: 'AlertTriangle',
      color: 'bg-error/10 text-error',
      action: 'Check Inventory'
    },
    {
      id: 'vendors',
      title: 'Vendor Requests',
      count: 5,
      description: 'Pending approvals',
      icon: 'Building2',
      color: 'bg-accent/10 text-accent-foreground',
      action: 'Review Vendors'
    },
    {
      id: 'support',
      title: 'Support Tickets',
      count: 12,
      description: 'Customer inquiries',
      icon: 'MessageCircle',
      color: 'bg-primary/10 text-primary',
      action: 'View Tickets'
    }
  ];

  const handleActionClick = (actionId) => {
    console.log(`Navigate to ${actionId} management`);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">Quick Actions</h3>
          <p className="text-sm text-muted-foreground">Items requiring attention</p>
        </div>
        <Button variant="outline" size="sm" iconName="Settings" iconPosition="left">
          Customize
        </Button>
      </div>
      <div className="space-y-4">
        {actions?.map((action) => (
          <div
            key={action?.id}
            className="flex items-center justify-between p-4 bg-muted/50 rounded-lg border border-border hover:bg-muted transition-smooth overflow-hidden"
          >
            <div className="flex items-center space-x-4 flex-1 min-w-0">
              <div className={`w-10 h-10 flex-shrink-0 rounded-lg flex items-center justify-center ${action?.color}`}>
                <Icon name={action?.icon} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2">
                  <h4 className="text-sm font-medium text-foreground truncate">{action?.title}</h4>
                  {action?.count > 0 && (
                    <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full flex-shrink-0">
                      {action?.count}
                    </span>
                  )}
                </div>
                <p className="text-xs text-muted-foreground truncate">{action?.description}</p>
              </div>
            </div>
            
            <div className="ml-2 flex-shrink-0">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleActionClick(action?.id)}
                iconName="ChevronRight"
                iconPosition="right"
                className="whitespace-nowrap"
              >
                <span className="hidden sm:inline">{action?.action}</span>
                <span className="sm:hidden">
                  <Icon name="ChevronRight" size={16} />
                </span>
              </Button>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-4">
          <Button variant="outline" fullWidth iconName="Plus" iconPosition="left" className="justify-center">
            <span className="truncate">Add Product</span>
          </Button>
          <Button variant="outline" fullWidth iconName="Users" iconPosition="left" className="justify-center">
            <span className="truncate">Manage Users</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;